import React from "react";
import classes from "./SearchField.module.scss";
import searchIcon from "../../assets/img/search.svg";
const SearchField = (props) => {
  const { keyword, setKeyword } = props;
  return (
    <form className={classes.form}>
      <label className={classes.search}>
        <img
          src={searchIcon}
          alt="検索"
          width={16}
          height={16}
          loading="eager"
        />
        <input
          type="text"
          name="p"
          placeholder="キーワードを入力"
          className={classes.searchInput}
          value={keyword}
          onChange={(e) => setKeyword(e.target.value)}
        />
      </label>
    </form>
  );
};

export default SearchField;
